module.exports = __webpack_public_path__ + "static/media/AwarenessUnderstanding.10298e87.jpg";